import React, { useState } from 'react'

import styled from 'styled-components';

import SectionItem from './SectionItem';
import CIRCLE_SWITCH from '../elements/CircleSwitch';

export default function SectionDesktop({title, pieces: items}) {
  const slidesPerView = 3;
  const bulletsNumber = items.length > slidesPerView ? items.length - 2 : 0;
  const visibleChunks = items.reduce((acc, item, index) => {
    if (index % 1 === 0) {
      acc.push([]);
    }
    acc[acc.length - 1].push(item);
    return acc;
  }, []);

  const [currentChunk, setCurrentChunk] = useState(0);

  const handleClickNext = (index) => {
    if (currentChunk < visibleChunks.length - 1 && index !== currentChunk) {
      setCurrentChunk(currentChunk + 1);
    }
  }
  let isNextSlide;
  return (
    <SECTION_DESKTOP>
      <div className="top">
        <h2>{title}</h2>
        <div className="pagination">
          {Array(bulletsNumber).fill().map((_, index) => (
            <CIRCLE_SWITCH key={index}
              $filled={currentChunk === index}
              onClick={() => setCurrentChunk(index)}
            />
          ))}
        </div>
      </div>
      <SWIPER_CONTAINER $currentChunk={currentChunk}>
        {visibleChunks.map((chunk, index) => (
          <div key={index}
            className={`visible-chunk ${((isNextSlide = index >= currentChunk + slidesPerView)) ? 'next' : ''}`}
            onClick={() => handleClickNext(index)}
          >
            {chunk.map((item, index) => (
              <SLIDE key={index}>
                <SectionItem
                  title={item.title}
                  authors={item.authors}
                  pieceId={item.id}
                  image_path={item.image_path}
                  isNextSlide={isNextSlide}
                />
              </SLIDE>
            ))}
          </div>
        ))}
      </SWIPER_CONTAINER>
    </SECTION_DESKTOP>
  )
}

const SLIDE = styled.div`
  flex: 0 0 calc((100vw - var(--main-side-padding) * 2 - 2.5rem) / 3); // margin + padding + 2 * gap 1.25rem
`;

const SWIPER_CONTAINER = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  gap: 1.25rem;

  overflow: hidden;

  & .visible-chunk {
    display: flex;
    flex-direction: row;
    flex: 0 0 calc((100vw - 2 * var(--main-side-padding)) / 3);
    gap: 1.25rem;
    transform: translateX(calc(-${props => props.$currentChunk * 100}% - ${props => props.$currentChunk * 1.25}rem));
    transition: transform 0.2s ease-in-out;
  }

  & .visible-chunk.next {
    opacity: 0.3;
  }
`;

const SECTION_DESKTOP = styled.section`
  margin-left: var(--main-side-padding);

  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap: 1.25rem;

  & h2 {
    font-size: 1.875rem;
    font-weight: 500;
    font-family: var(--primary-font);
  }

  & .top {
    padding-right: var(--main-side-padding);
    width: 100%;

    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  & .pagination {
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 0.5rem;
  }
`;